import React, { useState, useEffect, useMemo } from 'react';
import { withTranslation } from 'config/i18n';
import PageTitle from 'common/components/PageTitle/PageTitle';

import Head from 'next/head';
import axios, { API } from 'config/axios';
import useHandleResponse from 'utils/useHandleResponse';
import generateMetaData from 'utils/generateMetaData';
import { Container, Box } from '@material-ui/core';
import StyledBox from 'views/information_module/common/InformationTheme.styles';
import InformationPagesViewSkeleton from 'views/information_module/informationPagesView/InformationPagesViewSkeleton';

const InformationPagesView = (props) => {
  const {
    t, infoPageType, infoPageIdentifier, serverData, preferredSeoIdentifer,
  } = props;
  const [data, setData] = useState(serverData);
  const { handleError } = useHandleResponse();

  const breadCrumbProps = useMemo(
    () => ({
      links: [
        {
          text: t('fe_es_information_pages:eagleShare'),
          path: '/',
        },
        {
          text: t('fe_es_information_pages:information'),
          path: '/information',
        },
      ],
      breadCrumbsTitle: t(`fe_es_information_pages:${infoPageType}`),
    }),
    [infoPageType],
  );

  const getData = () => {
    axios
      .get(API.informationPages, {
        params: {
          identifier: infoPageIdentifier,
          preferred_seo_identifer: preferredSeoIdentifer,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        handleError(error, false);
      });
  };

  useEffect(() => {
    if (!serverData) {
      getData();
    }
  }, []);

  return (
    <StyledBox className="infoContentBody">
      {data ? (
        <Box pb={3}>
          <Head>{data.seo_values && generateMetaData(data.seo_values)}</Head>
          <PageTitle
            breadCrumbProps={breadCrumbProps}
            title={t(`fe_es_information_pages:${infoPageType}`)}
          />
          <Container>
            <Box
              pt={3}
              dangerouslySetInnerHTML={{
                __html: data.information_page.content,
              }}
            />
          </Container>
        </Box>
      ) : (
        <InformationPagesViewSkeleton />
      )}
    </StyledBox>
  );
};

export default withTranslation('fe_es_information_pages')(InformationPagesView);
